import React, { Component } from 'react';
import TablePagination from '@material-ui/core/TablePagination'
import { inject, observer } from 'mobx-react'

@inject('ReferralReportStore')
@observer
class ReferralPaginator extends Component {

  handlePageChange = (e, page) => {
    console.log(page)
    this.props.ReferralReportStore.handlePageChange(page)
  }

  handleChangeRowsPerPage = (e) => {
    this.props.ReferralReportStore.handleChangeRowsPerPage(e.target.value)
  }

  render() {

    const { count, page, limit } = this.props.ReferralReportStore

    return (
      <div>
        <TablePagination
          rowsPerPageOptions={[15, 30, 100]}
          component="div"
          count={count}
          rowsPerPage={limit}
          page={page}
          onChangePage={this.handlePageChange}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default ReferralPaginator;